import { IS_PRIME_MODE_ENABLED } from '@lib/constants'

const STORAGE_KEY = 'admin-prime-mode'

const readInitial = (): boolean => {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

let primeMode = readInitial()
const listeners = new Set<() => void>()

export const getPrimeMode = (): boolean => IS_PRIME_MODE_ENABLED && primeMode

export const setPrimeMode = (next: boolean): void => {
  if (primeMode === next) return
  primeMode = next
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next))
    } catch {
      // ignore quota / privacy mode
    }
  }
  listeners.forEach((l) => l())
}

export const subscribePrimeMode = (listener: () => void): (() => void) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export const PRIME_REQUEST_HEADER = 'x-admin-prime-request'
